import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';

@Injectable({
  providedIn: 'root'
})
export class PushNotficationService {
  constructor(private afMessaging: AngularFireMessaging) { }

  async requestPermissionAndGetToken(): Promise<string | null> {
    return new Promise<string | null>((resolve) => {
      this.afMessaging.requestToken.subscribe({
        next: (token) => resolve(token ?? null),
        error: () => resolve(null),
      });
    });
  }

  onForegroundMessages() {
    return this.afMessaging.messages;
  }
}
